/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const WorkManualGradingUnknownParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('unknown')],
]);
export class WorkManualGradingUnknown extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WorkManualGradingUnknownParser.decode(input).map(res => new WorkManualGradingUnknown(res));
    }
    static unsafeDecode(input) {
        return WorkManualGradingUnknown.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WorkManualGradingUnknownParser.encode(data);
    }
    static schema() {
        return WorkManualGradingUnknownParser.schema();
    }
}
